const LightTheme = {
    // Global colors
    textColor: "#212121",
    background: "#c4d9fc",
    hover: "rgba(150, 189, 255, 0.5)",
    whiteBlack: "#000",

    // Folder
    folderNameBarBg: "#b2b7f7",
    folderBorder: "#202020",
    folderNameBarBtnHover: "rgba(0, 21, 255, 0.2)",
    folderHoverBg: "rgba(0, 0, 0, 0.1)",
    folderHoverOutline: "rgb(0, 0, 0, 0.3)",
    folderFocusBg: "rgba(0, 0, 0, 0.2)",
    folderFocusOutline: "rgb(0, 0, 0, 0.4)",
    backButtonColor: "#41a83a",

    // Settings App
    settingsBg: "rgba(0, 0, 0, 0.1)",
    settingsOutline: "rgb(0, 0, 0, 0.3)",

    // Calculator App
    calcNumButtonBg: "rgba(0, 21, 255, 0.1)",
    calcOperatorButtonBg: "rgba(150, 189, 255, 0.5)",
    calcNumButtonHover: "rgba(0, 21, 255, 0.2)",
    calcOperatorButtonHover: "rgba(0, 21, 255, 0.3)",

    // Clock and Lgogo
    clockHover: "rgba(150, 189, 255, 0.5)",
    logoHover: "rgba(150, 189, 255, 0.5)",
    logoBorder: "#00B140",

    // StartMenu
    startMenuBg: "rgba(196, 217, 252, 0.95)",
    startSmallWidgetColor: "#212121",
    startSmallWidgetHover: "rgba(150, 189, 255, 0.5)",

    // Taskbar Icons
    iconBg: "rgba(0, 21, 255, 0.1)",
    iconBgHover: "rgba(0, 21, 255, 0.2)",

    // Calendar
    calendarBg: "rgba(196, 217, 252, 0.95)",
    calendarBorder: "#202020",
    calendarColorDefault: "#212121",
    calendarColorPrimary: "#000",
    calendarColorSecondary: "#595959",
    calendarColorCurrentDate: "#fff",
    calendarBgCurrentDate: "#006edc",
    calendarTodayClock: "#006edc",
    calendarColorNeighboringMonth: "#828282"
};

export default LightTheme;
